module.exports = __webpack_public_path__ + "img/qr_disabled.76516aa2.svg";